/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseReferentialTagConversation } from '../../models/api-response-referential-tag-conversation';
import { ReferentialTagConversation } from '../../models/referential-tag-conversation';

export interface UpdateReferentialTagConversation$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  ref: string;
      body: ReferentialTagConversation
}

export function updateReferentialTagConversation(http: HttpClient, rootUrl: string, params: UpdateReferentialTagConversation$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseReferentialTagConversation>> {
  const rb = new RequestBuilder(rootUrl, updateReferentialTagConversation.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('ref', params.ref, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseReferentialTagConversation>;
    })
  );
}

updateReferentialTagConversation.PATH = '/v1/api/ui/referential/tag/{ref}';
